import React, { useEffect } from "react"
import styled from "styled-components"
import * as Slider from "@radix-ui/react-slider"
import TextButton from "@common/ui/TextButton"
import ToggleGroup from "@common/ui/ToggleGroup"
import { useFilters } from "@lib/Filtering/useFilteredData"

export const formatPrice = (val: number) => {
  const formattedVal = Number(val).toLocaleString()
  return formattedVal
}

// TODO - Should come from payload
const marketingNames = {
  House: "House",
  Apartment: "Apartment",
}

const bedroomDisplayNames = {
  "0": "Studio",
  "1": "1 Bed",
  "2": "2 Bed",
  "3": "3 Bed",
}

type ResidenceFiltersProps = {
  className?: string
}

export type TFilters = {
  topologies: string[]
  beds: string[]
  price: [number, number]
  floor: [number, number]
}

const Filters: React.FC<ResidenceFiltersProps> = ({ className }) => {
  const {
    dynamicFilters,
    handleToggleChange,
    handleRangeChange,
    filters,
    handleReset,
  } = useFilters()

  const { priceRange, bedOptions, typologyOptions } = dynamicFilters

  const [localPrice, setLocalPrice] = React.useState(priceRange)

  useEffect(() => {
    setLocalPrice(priceRange)
  }, [priceRange])

  return (
    <FiltersWrapper className={className}>
      <div className="buildings">
        <div className="label">Typology</div>
        <ToggleGroup
          options={typologyOptions}
          labels={marketingNames}
          selected={filters.topologies}
          type="topologies"
          onClick={(value: string) => {
            handleToggleChange("topologies", value, true)
          }}
        />
      </div>
      <div className="price">
        <div className="label">Price</div>
        <div className="filter">
          <div className="price-values">
            <div className="price-value">£{formatPrice(localPrice[0])}</div>
            <div className="price-value">£{formatPrice(localPrice[1])}</div>
          </div>
          <form>
            <Slider.Root
              value={localPrice}
              className="SliderRoot"
              step={10000}
              min={priceRange[0]}
              max={priceRange[1]}
              onValueChange={(value) => {
                setLocalPrice(value as [number, number])
              }}
              onValueCommit={(value) => {
                handleRangeChange("price", value)
              }}
            >
              <Slider.Track className="SliderTrack">
                <Slider.Range className="SliderRange" />
              </Slider.Track>
              <Slider.Thumb className="SliderThumb" aria-label="Volume" />
              <Slider.Thumb className="SliderThumb" aria-label="Volume" />
            </Slider.Root>
          </form>
        </div>
      </div>

      <div className="beds">
        <div className="label">Bedrooms</div>
        <ToggleGroup
          labels={bedroomDisplayNames}
          options={bedOptions}
          selected={filters.beds}
          type="beds"
          onClick={(value: string) => {
            handleToggleChange("beds", value, false)
          }}
        />
      </div>

      <TextButton
        style={{
          width: "8rem",
          margin: "1.5rem 0",
          border: "var(--black) solid 1px",
          color: "var(--black)",
        }}
        variant="outline"
        onClick={() => {
          setLocalPrice(priceRange)
          handleReset()
        }}
      >
        Reset Filters
      </TextButton>
    </FiltersWrapper>
  )
}
export default Filters

const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 2rem 1rem 2em;
  width: 100%;
  height: 100%;
  gap: 1rem;
  color: #fff;
  overflow-y: auto;

  ::-webkit-scrollbar {
    display: none;
  }

  .label {
    font-family: primaryFont;
    font-size: 1.25rem;
    text-transform: uppercase;
    padding: 1rem 0;
    letter-spacing: 0.15em;
    color: var(--black);
  }

  .floors,
  .price,
  .beds,
  .buildings {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
  }

  .SliderRoot {
    position: relative;
    display: flex;
    align-items: center;
    user-select: none;
    touch-action: none;
    height: 2rem;
  }

  .SliderTrack {
    background-color: #ffffff49;
    position: relative;
    flex-grow: 1;
    height: 1px;
  }

  .SliderRange {
    background-color: var(--black);
    position: absolute;
    height: 1px;
  }

  .SliderThumb {
    cursor: pointer;
    display: block;
    width: 16px;
    height: 16px;
    background-color: var(--primary);
    border: 1px solid var(--black);
  }

  .floors .filter,
  .price .filter {
    color: var(--black);
  }

  .baths .filter,
  .buildings .filter,
  .beds .filter,
  .view .filter {
    width: 100%;
    display: flex;
    border: 1px solid var(--black);
    font-weight: bold;
    color: var(--black);

    button {
      all: unset;
    }

    .option {
      box-sizing: border-box;
      width: 100%;
      text-align: center;
      padding: 0.5rem 0;
      font-size: 1.25rem;
      cursor: pointer;
      transition: 0.3s;
    }

    .option:not(:last-child) {
      border-right: 1px solid white;
      transition: 0.3s;
    }

    .option.selected {
      background-color: var(--primary);
      color: white;
      transition: 0.3s;
    }
  }

  .floors .floor-values,
  .price .price-values {
    font-size: 1.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`
